import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HostListener } from '@angular/core';
import { allowPreviousPlayerStylesMerge } from '@angular/animations/browser/src/util';
import { PlatformLocation } from '@angular/common';
import { ApiService } from './services/api/api.service';
// import { WebSocketService } from './websocket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'DLP-Scss';
  template: string = `<img src="./assets/Loader-Anim.gif"/>`;

 // webSocketAPI: WebSocketService;
  greeting: any;
  name: string;


  constructor(private router?: Router, private location?: PlatformLocation, private data?: ApiService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // scroll to top
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.data.setTheme();
   // this.webSocketAPI = new WebSocketService(new AppComponent());
  }
}



